$(function() {
  var $menuButton = $('.common-header__menu-btn');
  var $dropdown = $('.common-header__menu-dropdown');
  var _scrollY = 0;

  if ($menuButton.length === 0 || $dropdown.length === 0) {
    return;
  }

  var MOBILE_BP = 980;

  function isMobile() {
    return window.innerWidth < MOBILE_BP;
  }

  function closeMenu() {
    $dropdown.removeClass('is-open');
    $menuButton.removeClass('is-open');
    $menuButton.attr('aria-expanded', 'false');
    $menuButton.find('p').text('MENU');
    $('body').css({ overflow: '', position: '', top: '', width: '' });
    if (isMobile()) {
      window.scrollTo(0, _scrollY);
    }
  }

  $menuButton.on('click', function() {
    var isOpen = $dropdown.hasClass('is-open');

    if (!isOpen) {
      $dropdown.addClass('is-open');
      $menuButton.addClass('is-open');
      $menuButton.attr('aria-expanded', 'true');
      $menuButton.find('p').text('CLOSE');
      if (isMobile()) {
        _scrollY = window.pageYOffset;
        $('body').css({ overflow: 'hidden', position: 'fixed', top: -_scrollY + 'px', width: '100%' });
      }
    } else {
      closeMenu();
    }
  });

  $dropdown.find('a').on('click', function() {
    closeMenu();
  });

  $dropdown.on('click', function(e) {
    e.stopPropagation();
  });

  $(document).on('click', function(e) {
    if ($dropdown.hasClass('is-open') && !$menuButton.is(e.target) && $menuButton.find(e.target).length === 0) {
      closeMenu();
    }
  });

  $(document).on('click', '.fixed-bottom-cta a, .local-fixed-cta a', function() {
    if ($dropdown.hasClass('is-open')) {
      closeMenu();
    }
  });
});
